import React, { useEffect, useState, useRef, useLayoutEffect } from "react"
import { graphql } from "gatsby"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { Observer } from "gsap/Observer"
import parse from "html-react-parser"
import { BoneLogo, EdlynLogo, EdlynLogo1929, EdlynLogo1980, EdlynLogoBig, GreenWheatLogo, WoodsLogo } from "../../icons"
import { Asset } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(Observer)

const Timeline = ({ title, years }) => {
  const [currentLogo, setCurrentLogo] = useState(<EdlynLogo1929 />)
  const timelineRef = useRef(null)
  const logoRef = useRef(null)
  const timelineInnerRef = useRef(null)

  useLayoutEffect(() => {
    const timelineItemsInner = document.querySelector(".timeline__items-inner")
    const timelineSection = document.querySelector(".timeline")
    const timelineProgress = document.querySelector(".timeline__progress-dot")

    const calculateAndUpdateHeight = () => {
      const items = document.querySelectorAll(".timeline__item")
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
      let totalHeight = 0

      items.forEach(item => {
        totalHeight += item.offsetHeight
      })

      totalHeight = totalHeight - (vh * 2)

      if (timelineInnerRef.current) {
        //timelineInnerRef.current.style.height = `${totalHeight}px`
      }
    }

    calculateAndUpdateHeight()
    window.addEventListener("resize", calculateAndUpdateHeight)

    const vh = (coef) => window.innerHeight * (coef/100);


    gsap.to(timelineItemsInner, {
      y: "-100%",
      scrollTrigger: {
        trigger: timelineInnerRef.current,
        start: "top top",
        end: () => `bottom ${vh(-250)}`,
        scrub: true,
        onToggle: self => {
          const extraClass = "timeline__scrolled"
          if (self.isActive) {
            timelineSection.classList.add(extraClass)
          } else {
            timelineSection.classList.remove(extraClass)
          }
        },
      },
    })

    gsap.to(timelineProgress, {
      top: "100%",
      ease: "none",
      scrollTrigger: {
        trigger: ".timeline",
        start: "top top",
        scrub: true,
      },
    })

    const updateLogoBasedOnScroll = () => {
      const items = document.querySelectorAll(".timeline__item")
      let targetYear = null

      items.forEach(item => {
        const rect = item.getBoundingClientRect()
        const itemYear = item.getAttribute("data-year")

        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          targetYear = itemYear
        }
      })

      switch (targetYear) {
        case "1929":
          setCurrentLogo(<EdlynLogo1929 />)
          break
        case "1988":
          setCurrentLogo(<EdlynLogo1980 />)
          break
        case "2012":
          setCurrentLogo(<EdlynLogoBig />)
          break
      }
    }

    ScrollTrigger.create({
      trigger: timelineRef.current,
      start: "top top",
      end: "bottom bottom",
      scrub: true,
      onUpdate: updateLogoBasedOnScroll,
    })

    return () => {
      window.removeEventListener("resize", calculateAndUpdateHeight)
    }
  }, [])

  return (
    <>
      <div className="timeline__title">
        {title && <h2>{parse(title)}</h2>}
      </div>
      <section className="timeline" ref={timelineRef}>
        <div className="timeline__logos">
          <div className="timeline__logo" ref={logoRef}>
            {currentLogo}
          </div>

          <div className="timeline__progress">
            <div className="timeline__progress-inner">
              <div className="timeline__progress-dot"></div>
            </div>
          </div>
        </div>
        <div className="timeline__inner" ref={timelineInnerRef}>
          <div className="timeline__overlay">
            <div className="timeline__items">
              <div className="timeline__items-inner">
                {years?.length > 0 && years.map((el, i) => (
                  <div key={i} className="timeline__item"
                       data-year={`${el.year.toLowerCase().trim()}`}>
                    <div className="timeline__item-image">
                      {el.images.length > 0 && el.images.map((el, index) => (
                        <Asset key={index} asset={el} />
                      ))}
                    </div>
                    <div className="timeline__item-content">
                      <div>
                        {el.year && <h3>{parse(el.year)}</h3>}
                        {el.richContent && <StructuredText data={el.richContent} />}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Timeline

export const query = graphql`
fragment TimelineProps on DatoCmsTimeline {
  ... on DatoCmsTimeline {
    id
    years {
      year
      richContent {
        value
      }
      images {
        ...InternalAssetProps
      }
    }
    title
  }
}
`
